function removeFreeProduct(productId) {
  jQuery.post('/cart/change.js', {
      quantity: 0,
      id: productId
    }, null, "json")
    .done(function(response) {
  
   document.dispatchEvent(new Event('cart:build'));
    });
  return false;
}
function validateGift(cart,notmet){
  
  const idExists = cart.items.some(item => item.properties.hasOwnProperty('_if>150=Free'));
const existingIds = cart.items.filter(item => item.properties.hasOwnProperty('_if>150=Free')).map(item => item.key);
  
    const idQty = cart.items.some(item => item.properties.hasOwnProperty('_if>150=Free') && item.quantity != 1);

  if(notmet){
     if (idExists && existingIds != undefined && existingIds.length > 0) {
existingIds.forEach(id => {
  removeFreeProduct(id);
});
     console.log('id existed but threshold not met - removed');
}
  }else{
         if (idExists && existingIds != undefined && existingIds.length > 0) {
           //gift already in cart
 $('#getfreeGift').hide();
         }else{
    
 $('#getfreeGift').show();
         }
  }
  
}
function checkGiftStatus(cart){
     let matchedCurrency = Shopify.currency.active;

    $('#freeGiftMessage, #getfreeGift, #CartDrawerForm').addClass(matchedCurrency);
   $('#CartDrawerForm').attr('currency',matchedCurrency);
       
  var currencyCode= Shopify.currency.active ;

  let getTotalPrice =  cart.total_price/100;
var amountUSD = 290;
// free gift amount
var conversionRate = Shopify.currency.rate;

var getconvertUSDprice = parseInt(getTotalPrice);
var getconvertUSDpriceConvert = parseInt((amountUSD * conversionRate));
  
if(getconvertUSDpriceConvert>getconvertUSDprice){
var matchedConversion = getconvertUSDpriceConvert - getconvertUSDprice;
console.log("Conversion for " + amountUSD + " AUD to " + matchedCurrency + ": " + matchedConversion.toFixed(2));
  
$('#freeGiftMessage').html('<p>You\'re '+currencyCode+' '+ matchedConversion.toFixed(2).replace(/\.00/,'')+' away from a Free Gift!</p>');
$('#freeGiftMessage').show();
$('.custom-function-form button').attr('disabled',true);

 $('#getfreeGift').removeClass('order-qualified');

validateGift(cart,true);
  
          }else{
  
              $('#getfreeGift').addClass('order-qualified');
          $('.custom-function-form button').removeAttr('disabled');
  $('#freeGiftMessage').hide();
validateGift(cart,false);
}


}


$(document).ready(function () {




    
  $('.swatches_option li').on('click', function() {
   var variant_id = $(this).attr('variant_id');
  $(this).parents('.product-details').find('[type="hidden"]').attr('value',variant_id);
    $(this).siblings().removeClass('selected');
    $(this).addClass('selected');
  });
  });

  document.addEventListener('DOMContentLoaded', function() {
    // Function to handle form submission without page reload
    function submitForm(event) {
      event.preventDefault();

        $('.custom-function-form button').hide();
      
      const form = event.target;
      const formData = new FormData(form);

      fetch(form.action, {
        method: form.method,
        body: formData,
      })
        .then(response => response.json())
        .then(data => {
         
        })
        .catch(error => {
          // Handle errors
          console.error('Error:', error);
           
          displayConfirmationMessage(form);
        });
    }

    // Function to display the confirmation message
    function displayConfirmationMessage(form) {
      const confirmationMessage = form.nextElementSibling;
      if (confirmationMessage) {
        confirmationMessage.style.display = 'block';
       
         document.dispatchEvent(new Event('cart:build'));
       location.reload(true);


         
        setTimeout(function() {
        
          confirmationMessage.style.display = 'none';
         $('#freeGiftMessage').hide();
         $("#closeButton").trigger("click");
          $('#cartAddedGift').show();
            },2000);
      }
    }

    // Attach the submitForm function to all forms with the class 'add-to-cart-form'
    const addToCartForms = document.querySelectorAll('.add-to-cart-form');
    addToCartForms.forEach(form => {
      form.addEventListener('submit', submitForm);
    });

 
  });






  document.addEventListener('DOMContentLoaded', function() {

  const quickViewContent = document.getElementById('quickViewContent');
  const closeButton = document.getElementById('closeButton');
const quickViewButtons = document.querySelectorAll('.quickViewButton');

quickViewButtons.forEach(function(button) {
    button.addEventListener('click', function() {
        quickViewContent.classList.remove('hidden');
    });
});

  closeButton.addEventListener('click', function() {
    quickViewContent.classList.add('hidden');

setTimeout(function(){     document.dispatchEvent(new Event('cart:open')); },200);
  });


  theme.cart.getCart().then(function(cart) {
checkGiftStatus(cart);});
    
  });


  document.addEventListener("cart:custom:update",function(event){
    let cart = event.detail.cart;

    checkGiftStatus(cart);
    console.log(cart);
    // CD code
    var cart_total = parseInt(cart.total_price);
    var delivery = parseInt($(".drawer .drawer__footer .cart__item-sub [delivery_price]").attr("delivery_price"));;
    var free_delivery = $(".drawer .drawer__footer .cart__item-sub [free_delivery_price]").attr("free_delivery_price");

    if(cart_total < free_delivery){
      $(".drawer .drawer__footer .in_delivery").css("display", "block");
      $(".drawer .drawer__footer .free_delivery").css("display", "none");
      $(".delivery_price_inner .delivery_text").css("display", "none");
      var in_delivery_cart_price = cart_total + delivery;
      var formatted = theme.Currency.formatMoney(in_delivery_cart_price, theme.settings.moneyFormat);
      setTimeout(function(){
      $(".drawer .drawer__footer [data-subtotal] .money").html(formatted);
      }, 150)
    }else{
      $(".drawer .drawer__footer .in_delivery").css("display", "none");
      $(".drawer .drawer__footer .free_delivery").css("display", "block");
      $(".delivery_price_inner .delivery_text").css("display", "block");
    }
    
  })



